export default function useDirtySnapshot(getState: () => unknown) {
  const capturedState = ref<string | null>(null)

  const capture = () => {
    capturedState.value = JSON.stringify(getState())
  }

  const isDirty = computed(() => capturedState.value !== null && capturedState.value !== JSON.stringify(getState()))

  return { isDirty, capture }
}
